/** CRA PUBLIC_URL without trailing slash (e.g. "/rayong"). Empty when served at site root. */
function normalizeBakedPublicPath(raw: string): string {
  const trimmed = raw.replace(/\/+$/, '');
  return trimmed === '.' ? '' : trimmed;
}

const BAKED_PUBLIC_PATH = normalizeBakedPublicPath(process.env.PUBLIC_URL || '');

/** First-path segments that are unified-admin SPA routes, not org slugs. */
const PORTAL_PATH_SEGMENTS = new Set([
  'login',
  'organizations',
  'chat-test',
  'agent-management',
  'tools',
  'docs',
  'status',
  'usage',
  'memory-summary',
  'guardrails',
  'settings',
  'tasks',
  'task-history',
  'agents',
  'chatbot-docs',
  'warn',
  '404',
  'static',
  'auth',
  'api',
  'health',
  'healthz',
  'readyz',
  'favicon.ico',
  'manifest.json',
  'robots.txt',
]);

/** First URL path segment when mounted at /{org}/… (shared frontend build). */
export function orgSlugFromBrowserPath(): string {
  if (typeof window === 'undefined') return '';
  const seg = window.location.pathname.split('/').filter(Boolean)[0] ?? '';
  if (!seg || PORTAL_PATH_SEGMENTS.has(seg)) return '';
  return seg;
}

/** Runtime public path: build-time PUBLIC_URL or /{org} from browser location. */
export function resolvePublicPath(): string {
  if (BAKED_PUBLIC_PATH) return BAKED_PUBLIC_PATH;
  const org = orgSlugFromBrowserPath();
  return org ? `/${org}` : '';
}

export const PUBLIC_PATH = resolvePublicPath();

/** React Router basename; omit when the app is mounted at /. */
export const routerBasename = PUBLIC_PATH || undefined;

/** Portal / unified login at site root. */
export const PORTAL_LOGIN_PATH = '/login';

/** Safe in-app path for post-login redirect (?returnTo=). Rejects open redirects. */
export function safeReturnPath(raw: string | null | undefined, fallback = '/'): string {
  if (!raw) return fallback;
  const path = raw.trim();
  if (!path.startsWith('/') || path.startsWith('//') || path.includes('://')) return fallback;
  return path;
}

/** True when this bundle is mounted under /{org} (e.g. /rayong) rather than at /. */
export function isOrgScopedApp(): boolean {
  return PUBLIC_PATH.length > 0;
}

/** Leave org-scoped React Router and open the shared portal login page. */
export function redirectToPortalLogin(replace = true): void {
  if (replace) {
    window.location.replace(PORTAL_LOGIN_PATH);
  } else {
    window.location.assign(PORTAL_LOGIN_PATH);
  }
}
